const MASK_CPF = "999.999.999-99";
const MASK_CNPJ = "99.999.999/9999-99";
const MASK_IDENTY = "99.999.999-9";
const MASK_PROCESS_NUMBER = "9999999-99.9999.9.99.9999";
const MASK_CEP = "99999-999";

export { MASK_CNPJ, MASK_CPF, MASK_IDENTY, MASK_PROCESS_NUMBER, MASK_CEP };
